module.exports = __webpack_public_path__ + "img/allthat_event_title_2.1a35f9b8.png";